import React, { useState } from "react";
import Footer from "../../CustomComponents/Footer/Footer";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial";
import FilterPackages from "../../CustomComponents/FilterPackages/FilterPackages";
import BannerMain from "../../CustomComponents/BannerMain/BannerMain";
import activitiesImg1 from "../../assets/images/activities-one.jpg";
import activitiesImg2 from "../../assets/images/activities-for-you-3.jpg";
import activitiesImg3 from "../../assets/images/activities-for-you-2.jpg";
import activitiesImg4 from "../../assets/images/activities-for-you-4.jpg";
import CustomSearchFormActivities from "../../CustomComponents/SearchForm/CustomSearchFormActivities/CustomSearchFormActivities";
import { useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";
import Header from "../../CustomComponents/Header/Header";
import Highlights from "../../CustomComponents/Highlights/Highlights";
import FilterActivities from "../../CustomComponents/FilterSection/FilterActivities";
import FilterActivitiesComponent from "../../CustomComponents/FilterActivitiesComponent/FilterActivitiesComponent";
import ActivityCard from "../../CustomComponents/NewComponents/NewUiActivities/ActivityCardSection";
import ActivityCardSection from "../../CustomComponents/NewComponents/NewUiActivities/ActivityCardSection";
import DestinationGallery from "../../CustomComponents/NewComponents/NewDestinationSection/DestinationGallery";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import NewUIBookWithUs from "../../CustomComponents/NewComponents/NewUIBookWithUs/NewUIBookWithUs";
import NewUiSearchFormActivity from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormActivity/NewUiSearchFormActivity";
import NewTestimonial from "../../CustomComponents/NewComponents/NewTestimonial/NewTestimonial";
import testimonialImg from "../../assets/images/new-testimonial.png";

function Activities() {
  const [footerDestinations, setFooterDestinations] = useState([]);

  const [loader, setLoader] = useState(false);
  useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append(
    //   "Authorization",
    //   "Bearer " + localStorage.getItem("token")
    // );

    const formData = new FormData();
    formData.append("limit", 7);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: formData,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setFooterDestinations(result?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  const isVerifiedToken = localStorage.getItem("isVerified");
  const role = localStorage.getItem("role");
  // const userToken = localStorage.getItem("userToken");

  const navigate = useNavigate();

  useEffect(() => {
    // const isVerifiedToken = localStorage.getItem('isVerified');
    const AccountStatus = localStorage.getItem("AccountStatus");
    // console.log(AccountStatus, "AccountStatus")
    // const role = localStorage.getItem('role');

    // console.log(isVerifiedToken, "token");
    // console.log(role, "role");

    if (AccountStatus === "disable") {
      console.error("Error: Invalid token or undefined for agent role");
      // showErrorToast("First Fill all required ")
      navigate("/agent-account");
    }
  }, [navigate]);

  return (
    <div id="activities">
      <PageMetaData
        title="Top Things to Do in Himachal Pradesh - Mountain Mysteries "
        description="Explore the best things to do in Himachal Pradesh, from thrilling adventures like trekking and paragliding to serene escapes in charming hill stations"
        keywords="Things to do in Himchal Pradesh "
      />

      <NewUiSearchFormActivity />

      {/* <BannerMain /> */}
      {/* <FilterActivitiesComponent /> */}

      <section className="top_bottom_same_padding new_ui_bg">
        <ActivityCardSection />
      </section>

      <section className="top_bottom_padding_white" style={{paddingBottom:"0"}}>
        <DestinationGallery footerDestinations={footerDestinations} />{" "}
      </section>

      <section className="common_padding_testimonial">
        <div className="container">
          {" "}
          <div className="testimonial_flex_sec">
            <div>
              {" "}
              <h4 className="text_left new_ui_heading mb-10">
                Our Customers 
                are Saying...
              </h4>
              <div className="google_rating">
                <div>
                  {" "}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#FFC107"
                    />
                    <path
                      d="M3.15283 7.3455L6.43833 9.755C7.32733 7.554 9.48033 6 11.9998 6C13.5293 6 14.9208 6.577 15.9803 7.5195L18.8088 4.691C17.0228 3.0265 14.6338 2 11.9998 2C8.15883 2 4.82783 4.1685 3.15283 7.3455Z"
                      fill="#FF3D00"
                    />
                    <path
                      d="M12.0002 22C14.5832 22 16.9302 21.0115 18.7047 19.404L15.6097 16.785C14.5721 17.5745 13.3039 18.0014 12.0002 18C9.39916 18 7.19066 16.3415 6.35866 14.027L3.09766 16.5395C4.75266 19.778 8.11366 22 12.0002 22Z"
                      fill="#4CAF50"
                    />
                    <path
                      d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                      fill="#1976D2"
                    />
                  </svg>{" "}
                  RATING
                </div>
                <div className="mt-10">
                  <span> 4.7</span>{" "}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                     width="18"
                    height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                   width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                     width="18"
                    height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                   width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                    width="18"
                    height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                  width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8390"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                     width="18"
                    height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8390)">
                      <path
                        d="M4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  <svg
                   width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6890_8399"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                     width="18"
                    height="18"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6890_8399)">
                      <path
                        d="M9.99935 6.58336V11.5L11.9993 13.0417L11.2493 10.5L13.1243 9.16669H10.791L9.99935 6.58336ZM4.85352 17.5L6.79102 11.1667L1.66602 7.50003H7.99935L9.99935 0.833359L11.9993 7.50003H18.3327L13.2077 11.1667L15.1452 17.5L9.99935 13.5834L4.85352 17.5Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div className="slider_sec">
              <NewTestimonial />{" "}
            </div>
          </div>
        </div>
      </section>
      <NewUIBookWithUs />
      <NewFooterUI />

      {/* <section>
        <div className="container">
          <div className="common_padding">
            <h3>Activities we offer</h3>
          </div>
          <div className="activities-for-you">
            <div className="activities-offer-main ">
              <div className="activities-offer-card">
                <Link to="">
                  <img src={activitiesImg1} alt="" />
                  <h2 className="activities-card-content">
                    Trekking & Camping
                  </h2>
                  <div className="activities-gradient"></div>
                </Link>
              </div>
              <div className="activities-offer-card">
                <Link href="">
                  <img src={activitiesImg2} alt="" />
                  <h2 className="activities-card-content">Adventure & Fun</h2>
                  <div className="activities-gradient"></div>
                </Link>
              </div>
              <div className="activities-offer-card">
                <Link href="">
                  <img src={activitiesImg3} alt="" />
                  <h2 className="activities-card-content">Wildlife & Nature</h2>
                  <div className="activities-gradient"></div>
                </Link>
              </div>
              <div className="activities-offer-card">
                <Link href="">
                  <img src={activitiesImg4} alt="" />
                  <h2 className="activities-card-content">
                    Culture & Exploration
                  </h2>
                  <div className="activities-gradient"></div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <Testimonial />
      <Highlights /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default Activities;
